// PeptideVault v6.5 — Data access helpers

// ══════════════════════════════════════════════════════
// DATA HELPERS
// ══════════════════════════════════════════════════════
function skuQty(sku) {
  if (!sku.transactions?.length) return 0
  return sku.transactions.reduce((a, t) => a + (t.type === 'in' ? +t.qty : -+t.qty), 0)
}

// Reduce a SKU's per-location quantities by `amount`, draining locations in order.
// Keeps location vial counts in sync when stock is removed/scanned out.
// Drains "not in storage" (unlocated) stock first, then storage locations.
// NOTE: called AFTER the out-transaction is recorded, so skuQty() already
// reflects the removal. Add `amount` back to get pre-removal on-hand.
function decrementSkuLocations(sku, amount) {
  const locTotal = (sku.locations || []).reduce((a, l) => a + (l.qty || 0), 0)
  const preRemovalOnHand = skuQty(sku) + amount
  const unlocated = Math.max(0, preRemovalOnHand - locTotal)
  const fromLocations = Math.max(0, amount - unlocated)
  if (fromLocations <= 0 || !sku.locations?.length) return
  let remaining = fromLocations
  for (const loc of sku.locations) {
    if (remaining <= 0) break
    const take = Math.min(loc.qty || 0, remaining)
    loc.qty = (loc.qty || 0) - take
    remaining -= take
  }
  sku.locations = sku.locations.filter(l => (l.qty || 0) > 0)
}

function peptideQty(p) {
  return (p.skus || []).reduce((a, s) => a + skuQty(s), 0)
}
function lowStockPeptides() {
  return S.peptides.filter(p => {
    if (p.archived) return false                 // archived → don't flag (no intent to restock)
    const hasSkus = (p.skus||[]).length > 0
    if (!hasSkus) return false                   // never stocked → don't flag
    const qty = peptideQty(p)
    if (qty <= 0) return true                    // depleted to zero → out of stock
    const thr = +(p.lowStockThreshold||0)
    if (!thr) return false
    return qty <= thr
  })
}
function statusBadge(p) {
  if (p.archived) return '<span class="badge badge-gray">Inactive</span>'
  const qty = peptideQty(p)
  const thr = +(p.lowStockThreshold||0)
  if (qty <= 0) return '<span class="badge badge-red">Out of Stock</span>'
  if (thr && qty <= thr) return '<span class="badge badge-yellow">Low Stock</span>'
  return '<span class="badge badge-green">In Stock</span>'
}
function getDoc(id) { return S.documents.find(d => d.id === id) }
function getPeptide(id) { return S.peptides.find(p => p.id === id) }
function getSku(pid, sid) {
  const p = getPeptide(pid)
  return p?.skus?.find(s => s.id === sid)
}
function docsByType(type) {
  // COA files are owned and presented by the COA catalog. Keep their document
  // records internally for file access/sync, but never duplicate them here.
  const visible = S.documents.filter(d => d.type !== 'coa')
  const docs = type === 'all' ? visible : visible.filter(d => d.type === type)
  if (!S.docSearch) return docs
  const q = S.docSearch.toLowerCase()
  return docs.filter(d => d.name.toLowerCase().includes(q) || d.originalName?.toLowerCase().includes(q))
}
function docTypeName(t) {
  return {coa:'COA',protocol:'Protocol',health:'Health Information',research:'Research',other:'Other'}[t]||t
}
function docTypeClass(t) {
  return {coa:'doc-type-coa',protocol:'doc-type-protocol',health:'doc-type-health',research:'doc-type-research',other:'doc-type-other'}[t]||'doc-type-other'
}
function isDocLinkedToPeptide(docId) {
  for (const p of S.peptides) {
    if (p.protocolDocIds?.includes(docId)) return p
    for (const s of (p.skus||[])) {
      if ((s.coaDocIds||[]).includes(docId)) return p
      if (s.coaDocId === docId) return p  // legacy fallback
    }
  }
  return null
}

export {
  skuQty,
  decrementSkuLocations,
  peptideQty,
  lowStockPeptides,
  statusBadge,
  getDoc,
  getPeptide,
  getSku,
  docsByType,
  docTypeName,
  docTypeClass,
  isDocLinkedToPeptide
}
